import type { FromModel } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const featureFlagModel = {
  id: Number,
  feature: String,
  percentage: Number,
  version: Number,
  createdAt: Date,
  updatedAt: Date,
};

export const CmsFeatureFlagsModel = createModel([featureFlagModel]);

export type CmsFeatureFlags = FromModel<typeof CmsFeatureFlagsModel>;
